module.exports = __webpack_public_path__ + "img/register.aa0947bd.svg";